
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Navigation/DropdownMenu.html",
      function () {
        return require("private-next-pages/Navigation/DropdownMenu.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Navigation/DropdownMenu.html"])
      });
    }
  